module.exports = __webpack_public_path__ + "2131aac02a107bc077c91803c4e6a859.png";